import { FULL_SCREEN_MODE, WINDOWED_MODE } from '@/vuex/types'

const isFullScreenMode = (state) => {
  return state.currentSlideMode === FULL_SCREEN_MODE
}

const isWindowedMode = (state) => {
  return state.currentSlideMode === WINDOWED_MODE
}

const isBackstateRoute = (_state, getters) => {
  return getters['featureToggles/canUseNewUiBackStage'] || (_state.route && _state.route.name !== 'PresentationBackstage')
}

const isPresenting = (_state, getters) => {
  return (getters.isWindowedMode ||
      getters.isFullScreenMode
  ) && isBackstateRoute(_state, getters)
}

const isBackstage = (state) => {
  return state.route && state.route.name === 'PresentationBackstage'
}

const isPresentingOrBackstage = (_, getters) => {
  return getters.isPresenting || getters.isBackstage
}

const presentationHasNotes = (state) => {
  return state.presentation &&
    state.presentation.slides &&
    state.presentation.slides.some((slide) => slide.notes)
}

const isAbTestCollab = () => {
  return false
}

const isTakenOwner = (state) => {
  return state.presentation &&
    state.currentUser &&
    state.presentation.takenOverBy === state.currentUser.id
}

const isDisableWhenNotOwner = (state) => {
  return isAbTestCollab() && !isTakenOwner(state)
}

const isAbTestWorkspace = (state) => {
  return isAbTestCollab() && state.presentation.accountId
}

const isOpeningPrivateFeedback = (state) => {
  return state.isOpeningPrivateFeedback
}

const presentationId = (state) => {
  return state.presentation?.id
}

export default {
  isFullScreenMode,
  isWindowedMode,
  isPresenting,
  isBackstage,
  isPresentingOrBackstage,
  presentationHasNotes,
  isTakenOwner,
  isAbTestCollab,
  isAbTestWorkspace,
  isDisableWhenNotOwner,
  isOpeningPrivateFeedback,
  presentationId,
}
